export const SMARTBANNER_COOKIE_TARGET = 'smartBannerCookie';
